import { Button, Form, Input, InputNumber, Popconfirm, Select, Table } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './ProgramTable.module.css'
import { connect } from 'react-redux';
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const {Option} = Select;
const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  select,
  selectOptions,
  number,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
      console.log('Saved');

    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    let input = null;
    if (select) {
        input = <Select ref={inputRef} onPressEnter={save} onBlur={save}>
            {selectOptions ? selectOptions.map((el)=>{
                return <Option value={el.value}>{el.text}</Option>
            }): null}
        </Select>
    }
    else if (number) {
        input = <InputNumber 
        className={styles.InputNumber} 
        ref={inputRef} 
        onPressEnter={save} 
        onBlur={save} />

    }
    else {
        input = <Input ref={inputRef} onPressEnter={save} onBlur={save} />
    }
    let text = record[dataIndex];
    selectOptions ? [...selectOptions].forEach((el)=>{
      if (record[dataIndex] === el.value) {
        text = el.text;
      }
    }) : text = children;
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        
        {input}
      </Form.Item>
    ) : (
      <div
        className={styles.TextCell} 
        onMouseEnter={toggleEdit}
        
      >
        {text}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

const ProgramTable = ({value , setValue , disabled , levels}) => {
  const [dataSource, setDataSource] = useState(value ? value : []);
  const initialValue = value;
  const [count, setCount] = useState(2);

    useEffect(()=>{
        setValue(dataSource)
    } , [dataSource , setValue])
    useEffect(()=>{
      setDataSource(initialValue);
    } , [disabled ])

  const handleDelete = (id) => {
    const newData = dataSource.filter((item) => item.id !== id);
    setDataSource(newData);
  };

  const defaultColumns = [
    {
      title: 'سطح ترم',
      dataIndex: 'level',
      width: '50%',
      editable: true,
      select : true,
      selectOptions : levels
    },
    {
      title: 'تعداد دوره',
      dataIndex: 'term_count',
      width : '30%',
      editable: true,
      number : true
    },
    {
      title: 'عملیات',
      dataIndex: 'operation',
      align : 'center',
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm title="مطمئن هستید که می‌خواهید این سطر را حذف کنید؟" onConfirm={() => handleDelete(record.id)}>
            <Button danger type='text'>حذف</Button>
          </Popconfirm>
        ) : null,
    },
  ];

  const handleAdd = () => {
    const newData = {
      id: dataSource[dataSource.length - 1] ? dataSource[dataSource.length - 1].id + 1 : 1,
      level: 1,
      term_count: '1',
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        select : col.select,
        selectOptions : col.selectOptions,
        dataIndex: col.dataIndex,
        number : col.number,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <div className={styles.ProgramTable} id='ProgramTable'>
    
      <Table
        components={components}
        className={[disabled ? styles.DisabledTable : null].join(' ')}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
        <Button
        onClick={handleAdd}
        type="link"
        className={styles.AddRowBtn}
      >
        + اضافه کردن سطر جدید
      </Button>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
export default connect(mapStateToProps)(ProgramTable);